import { defineStore } from 'pinia';
import { useHttp } from '@/http/http';
import { statusCheck } from '../public';
import Swal from 'sweetalert2';

export const useTerminalsStore = defineStore('terminal', {
    state: () => ({
      terminal:[],
      terminals : [],
      totalEntries: 0,
      currentPage: 1,
      itemsPerPage: 10,
    }),
    actions: {
      async fetchTerminals(page = this.currentPage, perPage = this.itemsPerPage, filters = {}) {
        const url = `/api/admin/terminal/list?per_page=${perPage}&page=${page}`;
        let params = new URLSearchParams();
      
        if (filters.tid) params.append('tid', filters.tid);
        if (filters.serialNumber) params.append('serial_number', filters.serialNumber);
        if (filters.driverId) params.append('driver_id', filters.driverId);
        if (filters.fromDate) params.append('from', filters.fromDate);
        if (filters.toDate) params.append('to', filters.toDate);
        if (filters.sort_by) params.append('sort_by', filters.sort_by);
        if (filters.order) params.append('order', filters.order);

      
        try {
          const response = await useHttp().get(`${url}&${params.toString()}`);
          this.terminals = response.data.terminals;
          this.totalEntries = response.data.total;
          this.currentPage = page;
          this.itemsPerPage = perPage;
        } catch (error) {
          console.error('Error fetching terminals:', error);
          throw error;
        }
      },
      async downloadTerminalReport(filters = {}) {
        try {
          const url = '/api/admin/terminalPerformance/export';
          const params = new URLSearchParams();
          
          // 添加篩選參數
          if (filters.period) params.append('period', filters.period);
          if (filters.state) params.append('state', filters.state);
          if (filters.payment_method) params.append('payment_method', filters.payment_method);
          if (filters.inactive_period) params.append('inactive_period', filters.inactive_period);
          if (filters.fleet_id) params.append('fleet_id', filters.fleet_id);
          if (filters.search) params.append('search', filters.search);
          if (filters.custom_start) params.append('custom_start', filters.custom_start);
          if (filters.custom_end) params.append('custom_end', filters.custom_end);
          
          const queryString = params.toString();
          const fullUrl = queryString ? `${url}?${queryString}` : url;
          
          const response = await useHttp().get(fullUrl, {
            responseType: 'blob' // 指定響應類型為 blob，用於下載文件
          });
          
          // 創建 Blob 物件
          const blob = new Blob([response.data], { type: 'text/csv' });
          
          // 使用 URL.createObjectURL 生成下載鏈接
          const downloadUrl = URL.createObjectURL(blob);
          
          // 創建一個隱藏的 <a> 標籤並觸發點擊下載
          const link = document.createElement('a');
          link.href = downloadUrl;
          link.setAttribute('download', 'terminal_report.csv'); // 設置下載的檔名
          document.body.appendChild(link);
          link.click();
          
          // 移除連結
          document.body.removeChild(link);
          
          // 釋放 URL 物件
          URL.revokeObjectURL(downloadUrl);
        } catch (error) {
          console.error('Error downloading terminal report:', error);
          throw error;
        }
      },
      async createTerminal(payload) {
        try {
          const response = await useHttp().post('/api/admin/terminal/create', payload);
          if (statusCheck(response.data)) {
            Swal.fire({
              icon: 'success',
              title: response.data.message,
              showConfirmButton: false,
              timer: 1500
            });
            const filters = ({
              tid: '',
              serialNumber: '',
              driverId: '',
              subgroup: '',
              fromDate: '',
              toDate: '',
              sort_by:'created_at',
              order:'desc',
            });
            this.fetchTerminals(1,10,filters); // 成功後刷新子群列表
          } else {
            return false;
          }
        } catch (error) {
          console.error('Error creating terminal:', error);
          throw error;
        }
      }, 
      async getTerminalById(terminaId){
        try {
          const response = await useHttp().get(`/api/admin/terminal/info?id=${terminaId}`);
          if (statusCheck(response.data)) {
              this.terminal = response.data.terminal;
            } else {
              console.error('Failed to fetch drivers');
            }
          } catch (error) {
            console.error('Error fetching driver:', error);
          }
      },
      async updateTerminal(payload) {
        try {
          const response = await useHttp().post('/api/admin/terminal/update', payload);
          if (statusCheck(response.data)) {
            Swal.fire({
              icon: 'success',
              title: response.data.message,
              showConfirmButton: false,
              timer: 1500
            });
            const filters = ({
              tid: '',
              serialNumber: '',
              driverId: '',
              subgroup: '',
              fromDate: '',
              toDate: '',
              sort_by:'created_at',
              order:'desc',
            });
            this.fetchTerminals(1,10,filters); // 成功後刷新子群列表
          } else {
            return false;
          }
        } catch (error) {
          console.error('Error updating terminal:', error);
          throw error;
        }
      },
      changePage(page) {
        if (page >= 1 && page <= this.totalPages) {
          this.currentPage = page;
          this.fetchTerminals();
        }
      },
    },
    getters: {
      paginatedData(state) {
        return state.terminals;
      },
      totalPages(state) {
        return Math.ceil(state.totalEntries / state.itemsPerPage);
      },
    },
  }
);